import React, { useState } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import Barchart from "./Barchart";
import Barchartmaincat from "./Barchartmaincat";
import { Formik } from "formik";
import * as Yup from "yup";
import { ReportService } from "../../../services/reports-service";

export const Salescontent = () => {
  const [categoryname, setCategory] = useState([]);
  const [totalorders, setTotalOrders] = useState([]);
  const [deliveryarea, setDeliveryarea] = useState([]);
  const [deliveryareaorders, setDeliveryareaOrders] = useState([]);

  const onSubmitForm = async (
    values,

    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations

    try {
      const result = await ReportService.reportdateDetails(values.date);

      let totalOrders = [];
      let category = [];
      let deliveryarea = [];
      let deliveryareaOrders = [];

      result.category.map((item, i) => category.push(item.category));
      setCategory(category);

      result.category.map((item, i) => totalOrders.push(item.total_orders));
      setTotalOrders(totalOrders);

      result.delivery_area.map((item, i) =>
        deliveryarea.push(item.delivery_area)
      );
      setDeliveryarea(deliveryarea);

      result.delivery_area.map((item, i) =>
        deliveryareaOrders.push(item.total_orders)
      );
      setDeliveryareaOrders(deliveryareaOrders);
    } catch (err) {}
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Formik
            initialValues={{
              date: "",
            }}
            validationSchema={Yup.object().shape({})}
            onSubmit={onSubmitForm}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              touched,
              values,
              submitForm,
              isValid,
            }) => (
              <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <label htmlFor="validationCustom08">Select Date</label>
                    <div className="input-group">
                      <input
                        name="date"
                        type="date"
                        className="form-control"
                        id="dateID"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.date}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="col-md-4 mt-4"
                  style={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <button
                    type="button"
                    className="ms-btn-icon btn-primary"
                    name="button"
                    onClick={submitForm}
                  >
                    <i className="material-icons">arrow_forward</i>
                  </button>
                </div>
              </div>
            )}
          </Formik>
        </div>

        {/* Recent Placed Orders< */}
        <div className="col-12">
          <div class="ms-panel">
            <div class="ms-panel-header">
              <h6> City</h6>
            </div>
            <div class="ms-panel-body">
              <Barchart
                deliveryarea={deliveryarea}
                deliveryareaorders={deliveryareaorders}
              />
            </div>
          </div>
        </div>
        <div className="col-12">
          <div class="ms-panel">
            <div class="ms-panel-header">
              <h6>Main Category</h6>
            </div>
            <div class="ms-panel-body">
              <Barchartmaincat
                totalorders={totalorders}
                categoryname={categoryname}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Salescontent;
